import React, { useEffect, useState } from 'react';
import Auxiliary from 'hoc/Auxiliary';
import Paper from '@material-ui/core/Paper';
import classes from 'components/FuelVendor/FuelVendorDetails/FuelVendorDetail.module.css';
import { isBlank, isEmptyObject } from 'components/Common/Utils/StringUtils';
import Styles from '../FuelVendorDetail.module.css';
import { Grid, MuiThemeProvider, TextField } from '@material-ui/core';
import cs from 'classnames';
import { INTEGRATION_TYPES_THEME } from '../FuelVendorDetailMuiTheme';
import { connect } from 'react-redux';
import * as actions from 'components/FuelVendor/store/actions';
import { withRouter } from 'react-router-dom';
import validateFuelFields from '../Validation/FuelValidation';

const InteractiveType = (props) => {
    const {
        displayType,
        fuelVendorAccount,
        updateFuelAccount,
        toggleEditFuelDetails,
        updatedFuelVendorAccount,
        discardChanges,
        toggleSaveButton,
        toggleEditDetails
    } = props;

    const vendor_name = isBlank(updatedFuelVendorAccount.vendor_name)
        ? ''
        : updatedFuelVendorAccount.vendor_name;
    const message = `No additional information is required for an Interactive ${vendor_name}  configuration`;
    const [interactiveInfo, setInteractiveInfo] = useState(
        isEmptyObject(fuelVendorAccount.interactive)
            ? {
                  security_card_number: '',
                  interactive_user_name: '',
                  interactive_password: ''
              }
            : updatedFuelVendorAccount.interactive
    );

    const defErrorConfig = {
        isInvalid: false,
        message: ''
    };
    const [field, setFieldValidation] = useState({
        security_card_number: defErrorConfig,
        interactive_user_name: defErrorConfig,
        interactive_password: defErrorConfig
    });

    useEffect(() => {
        updateFuelAccount({ ...updatedFuelVendorAccount, interactive: interactiveInfo });
    }, [interactiveInfo]);

    useEffect(() => {
        if (discardChanges) {
            setInteractiveInfo(fuelVendorAccount.interactive);
            setFieldValidation({
                security_card_number: defErrorConfig,
                interactive_user_name: defErrorConfig,
                interactive_password: defErrorConfig
            });
        }
    }, [discardChanges]);

    const handleChange = (event) => {
        let { name, value } = event.target;
        setInteractiveInfo({ ...interactiveInfo, [name]: value });
        validateFields(event);
        toggleEditDetails(true);
    };

    const validateFields = (event) => {
        const { name } = event.target;
        const result = validateFuelFields(event);
        setFieldValidation({ ...field, [name]: result });
        if (result.invalid) {
            toggleSaveButton(true);
        } else {
            toggleSaveButton(false);
        }
    };

    return (
        <Auxiliary>
            {displayType.comDataInteractive ? (
                <MuiThemeProvider theme={INTEGRATION_TYPES_THEME}>
                    <Paper elevation={0} className={Styles.defaultPaperHeight}>
                        <Grid container justify={'space-between'} direction={'row'}>
                            <Grid item xs={12} className={cs(classes.extraPadding)}>
                                <label
                                    className={classes.interactiveHeaderText}
                                    id={'Security_Header_Properties'}
                                >
                                    Security Header Properties
                                </label>
                            </Grid>
                            <Grid item xs={12} className={classes.lineSpace}>
                                <hr className={classes.line} />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                className={cs(classes.extraTopSpace, classes.extraPadding)}
                            >
                                <TextField
                                    className={cs(classes.textField, classes.fieldWidth)}
                                    required
                                    label={'Security Card Number'}
                                    name={'security_card_number'}
                                    value={interactiveInfo.security_card_number}
                                    disabled={!toggleEditFuelDetails}
                                    onChange={(event) => handleChange(event)}
                                    onBlur={(event) => validateFields(event)}
                                    error={field.security_card_number.invalid}
                                    helperText={field.security_card_number.message}
                                    id={'security_card_number'}
                                    fullWidth
                                    variant="filled"
                                    margin="dense"
                                />
                            </Grid>
                            <Grid item xs={12} className={cs(classes.extraPadding)}>
                                <TextField
                                    className={cs(classes.textField, classes.fieldWidth)}
                                    required
                                    label={'User Name'}
                                    name={'interactive_user_name'}
                                    value={interactiveInfo.interactive_user_name}
                                    disabled={!toggleEditFuelDetails}
                                    onChange={(event) => handleChange(event)}
                                    onBlur={(event) => validateFields(event)}
                                    error={field.interactive_user_name.invalid}
                                    helperText={field.interactive_user_name.message}
                                    id={'interactive_user_name'}
                                    fullWidth
                                    variant="filled"
                                    margin="dense"
                                />
                            </Grid>
                            <Grid item xs={12} className={cs(classes.extraPadding)}>
                                <TextField
                                    className={cs(classes.textField, classes.fieldWidth)}
                                    required
                                    label={'Password'}
                                    name={'interactive_password'}
                                    value={interactiveInfo.interactive_password}
                                    disabled={!toggleEditFuelDetails}
                                    onChange={(event) => handleChange(event)}
                                    onBlur={(event) => validateFields(event)}
                                    error={field.interactive_password.invalid}
                                    helperText={field.interactive_password.message}
                                    id={'interactive_password'}
                                    fullWidth
                                    variant="filled"
                                    margin="dense"
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                </MuiThemeProvider>
            ) : (
                <Paper elevation={0} className={classes.emptyPaper}>
                    <label className={classes.displayProperties}>{message}</label>
                </Paper>
            )}
        </Auxiliary>
    );
};

const mapStateToProps = (state) => {
    return {
        fuelVendorAccount: state.fuelVendor.fuelVendorAccount,
        updatedFuelVendorAccount: state.fuelVendor.updatedFuelVendorAccount,
        discardChanges: state.fuelVendor.discardChanges
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateFuelAccount: (account) => dispatch(actions.updateFuelAccount(account)),
        toggleSaveButton: (flag) => dispatch(actions.toggleSaveButton(flag)),
        toggleEditDetails: (flag) => dispatch(actions.toggleEditDetails(flag))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InteractiveType));
